export const MaxThroughPutEnum = {
  LinkSpeed: [
    { key: 0, value: "Auto" },
    { key: 1, value: "100Mb/s" },
    { key: 2, value: "1Gb/s" },
    { key: 3, value: "2.5Gb/s" },
    { key: 4, value: "5Gb/s" },
    { key: 5, value: "10Gb/s" }
  ],
  PassFailLimit: [
    // { key: 0, value: "IEEE 802.3an (10G Copper)" },
    // { key: 1, value: "IEEE 802.3an* (10G Copper, Quick)" },
    // { key: 2, value: "IEEE 802.3bz (2.5|5G Copper)" },
    // { key: 3, value: "IEEE 802.3bz* (2.5|5G Copper, Quick)" },
    // { key: 4, value: "IEEE 802.3ab (1G Copper)" },
    // { key: 5, value: "IEEE 802.3ab* (1G Copper, Quick)" },
    // { key: 6, value: "IEEE 802.3ae (10G Fiber)" },
    // { key: 7, value: "IEEE 802.3ae* (10G Fiber, Quick)" },
    { key: 9, value: "IEEE 802.3* (Quick)" },
    { key: 10, value: "IEEE 802.3" },
    { key: 8, value: "Custom" }
  ],
  TestTemplate: [
    { key: 0, value: "Quick (1518)" },
    { key: 1, value: "Intermediate (64, 1518)" },
    { key: 2, value: "Detailed (64, 256, 512, 1518)" },
    { key: 3, value: "Jumbo (64, 1518, 10000)" }
  ],
  FrameLossLimit: [{ key: 0, value: "Count" }, { key: 1, value: "Percent %" }],
  DurationMap: [
    { key: 0, value: 100 },
    { key: 1, value: 10 },
    { key: 2, value: 200 },
    { key: 3, value: 10 },
    { key: 4, value: 10 },
    { key: 5, value: 10 },
    { key: 6, value: 1000 },
    { key: 7, value: 10 },
    { key: 9, value: 10 },
    { key: 10, value: 10 }
  ]
};
